import { useState } from 'react'
import classNames from 'classnames'
import { Button } from '@/atoms/Button'
import { ResponsiveFlexRow } from '@/atoms/FlexContainers'
import { HeadingSM } from '@/atoms/Text'
import { paths } from '@/constants/paths'
import { useAboutContext } from '@/contexts/AboutContext'
import { ProjectTile } from '@/molecules/ProjectTile'
import { useTranslate } from '@/utils/translate/translate-client'

function getProjectTileHref(projectType: string, slug: string) {
  if (projectType === 'movie') {
    return paths.movies.detail(slug)
  } else if (projectType === 'series') {
    return paths.shows.detail(slug)
  }
}

export const OurTitlesSection = () => {
  const { tiles } = useAboutContext()
  const { t } = useTranslate('about')
  const [seeMore, setSeeMore] = useState(false)

  const seeMoreText = t('seeMore', 'See More')
  const seeLessText = t('seeLess', 'See Less')

  const handleClick = () => {
    setSeeMore(!seeMore)
  }

  return (
    <section className="bg-core-gray-950 py-[72px]" id="titles">
      <HeadingSM className="photon-heading-xl mx-auto max-w-[238px] pb-8 text-center lg:max-w-none" weight="bold">
        {t('ourMoviesAndShows', 'Our Movies + Shows')}
      </HeadingSM>
      <div className="px-8 xl:grid xl:grid-cols-12">
        <ResponsiveFlexRow className="col-span-10 col-start-2 mx-auto flex-wrap items-center justify-center gap-8">
          {tiles.map((tile, index) => (
            <div className={classNames({ 'hidden md:block': !seeMore && index > 3 })} key={tile.slug}>
              <ProjectTile
                discoveryPosterCloudinaryPath={tile.imageCloudinaryPath}
                discoveryPosterTransformation=""
                href={getProjectTileHref(tile.projectType, tile.slug)}
                name={tile.name}
                slug={tile.slug}
                projectType={tile.projectType}
                sortOrder={index}
              />
            </div>
          ))}
        </ResponsiveFlexRow>
      </div>
      <div className="px-8 pt-8 md:hidden">
        <Button className="h-14 w-full" onClick={handleClick} variant="core-gray-900">
          {seeMore ? seeLessText : seeMoreText}
        </Button>
      </div>
    </section>
  )
}
